import AutocompleteStore from 'core/stores/AutocompleteStore.js';

export const SPECIALTY_URL =
    '/api/professionals/v1/specialty-interest-search/?show=site&limit=25';

/**
 * The specialty / special-interest field on the health fund widget.
 *
 * Ported from the `<auto-complete params="name: 'specialty' …">` element in
 * insurer_widget.html. The fund id goes up with the query so results can be
 * ordered for that fund, exactly as directory/widget/autocomplete.js did.
 */
export default class SpecialtyAutocompleteStore extends AutocompleteStore {
    constructor(healthFundId, parentStore) {
        super(SPECIALTY_URL, parentStore);
        this.healthFundId = healthFundId || null;
    }

    transformSearchParams(params) {
        if (this.healthFundId) {
            params.health_fund_id = this.healthFundId;
        }
        return params;
    }

    /**
     * The original auto-selected when what the user typed already matched the
     * top result exactly, on either the public or the professional name, so
     * that typing a specialty in full and hitting search worked without
     * picking from the list.
     */
    exactMatch(value) {
        if (!value || !this.results.length) {
            return null;
        }
        const typed = value.toLowerCase();
        const first = this.results[0];
        const matches = [first.name, first.professionalName]
            .filter(Boolean)
            .some((name) => name.toLowerCase() === typed);
        return matches ? first : null;
    }
}
